import { BaseApiService } from "@/utils/BaseApiService";
import Link from "next/link";
import React, { useState, useEffect } from "react";
import { useRouter } from 'next/router';

const Register = () => {
  const [countryList, setCountryList] = useState([]);
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const router = useRouter();

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobileNo: '',
    password: '',
    passwordSecure: true,
    confirmPassword: '',
    confirmPasswordSecure: true,
    selectedCountry: '',
    showCountryOptions: false
  });

  const updateState = (data) => setState((state) => ({ ...state, ...data }));

  const {
    firstName,
    lastName,
    email,
    mobileNo,
    password,
    confirmPassword,
    selectedCountry
  } = state;

  const fetchCountries = async () => {
    let searchParameters = { searchTerm: "", offset: 0, limit: 10 };
    try {
      const response = await new BaseApiService("/lookups/countries").getRequestWithJsonResponse(
        searchParameters
      );
      if (response && response.records) {
        setCountryList(response.records);
      } else {
        console.error("Unexpected response structure:", response);
      }
    } catch (error) {
      console.error("fetchCountries:fetchDataFromServer>>>>", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const register = async (event) => {
    event.preventDefault(); // Prevent default form submission
    setErrorMessage(''); // Clear previous error messages
    setSuccessMessage(''); // Clear previous success messages

    if (!firstName || !lastName || !email || !mobileNo || !password || !confirmPassword || !selectedCountry) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords don't match.");
      return;
    }

    setLoading(true); // Start loader

    let registerRequest = {
      firstName,
      lastName,
      emailAddress: email,
      phoneNumber: mobileNo,
      password,
      confirmPassword,
      countryId: selectedCountry?.id,
      countryName: selectedCountry?.name
    };

    try {
      const response = await new BaseApiService("/auth/student/register").postRequestWithJsonResponse(registerRequest);
      if (response.status === "Success") {
        setSuccessMessage('Registration successful! Redirecting...');
        setTimeout(() => {
          router.push('/verification'); // Adjust the path to your verification page
        }, 2000); // Redirect after a short delay to show the success message
      } else {
        setErrorMessage(response.message || "Registration failed. Please try again.");
      }
    } catch (error) {
      setErrorMessage(error.message || "An error occurred during registration.");
    } finally {
      setLoading(false); // Stop loader
    }
  };

  return (
    <div className="col-lg-6">
      <div className="rbt-contact-form contact-form-style-1 max-width-auto">
        <h3 className="title">Register</h3>
        <form className="max-width-auto" onSubmit={register}>
          <div className="form-group">
            <input
              name="register-firstname"
              type="text"
              value={firstName}
              placeholder="First name"
              onChange={(e) => updateState({ firstName: e.target.value })}
            />
            <span className="focus-border"></span>
          </div>

          <div className="form-group">
            <input
              name="register-lastname"
              type="text"
              value={lastName}
              onChange={(e) => updateState({ lastName: e.target.value })}
              placeholder="Last name"
            />
            <span className="focus-border"></span>
          </div>

          <div className="form-group">
            <input
              name="register-email"
              type="text"
              value={email}
              onChange={(e) => updateState({ email: e.target.value })}
              placeholder="Email *"
            />
            <span className="focus-border"></span>
          </div>

          <div className="form-group">
            <input
              name="register-mobile"
              type="text"
              value={mobileNo}
              placeholder="Phone number"
              onChange={(e) => updateState({ mobileNo: e.target.value })}
            />
            <span className="focus-border"></span>
          </div>

          <div className="form-group">
            <select
              value={selectedCountry ? selectedCountry.id : ''}
              onChange={(e) => {
                const selectedCountryObject = countryList.find(country => String(country.id) === e.target.value);
                if (selectedCountryObject) {
                  updateState({ selectedCountry: selectedCountryObject });
                } else {
                  console.error("Selected country is undefined. Please check the id values.");
                }
              }}
            >
              <option value="">Select Country</option>
              {countryList.length > 0 ? (
                countryList.map((country, index) => (
                  <option key={index} value={country.id}>
                    {country.name}
                  </option>
                ))
              ) : (
                <option>No Countries Available</option>
              )}
            </select>
          </div>

          <div className="form-group">
            <input
              name="register-password"
              type="password"
              value={password}
              onChange={(e) => updateState({ password: e.target.value })}
              placeholder="Password *"
            />
            <span className="focus-border"></span>
          </div>

          <div className="form-group">
            <input
              name="register-conpassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => updateState({ confirmPassword: e.target.value })}
              placeholder="Confirm Password *"
            />
            <span className="focus-border"></span>
          </div>

          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}

          {successMessage && (
            <div className="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}

          <div className="form-submit-group">
            <button
              type="submit"
              className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
              disabled={loading} // Disable button while loading
            >
              <span className="icon-reverse-wrapper">
                <span className="btn-text">
                  {loading ? 'Registering...' : 'Register'}
                </span>
                {!loading && (
                  <>
                    <span className="btn-icon">
                      <i className="feather-arrow-right"></i>
                    </span>
                    <span className="btn-icon">
                      <i className="feather-arrow-right"></i>
                    </span>
                  </>
                )}
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;